<template>
	<div class="form__group">
		<multiselect :options="options" :placeholder="placeholder" :allow-empty="allowEmpty" label="label" track-by="id"
		             :searchable="false" :multiple="multiple" :show-labels="false" v-model="selected"
		             :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }">>
		</multiselect>

		<label class="form__label">Content</label>
		<div class="form__validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import Select from './Select';

	export default {
		name: 'FormControlContentType',
		mixins: [Select],
		data() {
			return {
				options: [
					{
						label: 'Acquisition search',
						id: 8,
					},
					{
						label: 'Advisory service research',
						id: 4,
					},
					{
						label: 'Client document',
						id: 6,
					},
					{
						label: 'Conference document',
						id: 10,
					},
					{
						label: 'Country research',
						id: 2,
					},
					{
						label: 'Marketing materials',
						id: 5,
					},
					{
						label: 'Opportunity tracking',
						id: 11,
					},
					{
						label: 'Pitch document',
						id: 3,
					},
					{
						label: 'Sector research',
						id: 1,
					},
					{
						label: 'Strategic review',
						id: 7,
					},
					{
						label: 'Third party research',
						id: 9,
					},
				],
			}
		},
	}
</script>

